import React, { useState } from 'react';
import PuzzleGrid from './PuzzleGrid';
import { getDifficulty } from '../utils/puzzleUtils';

const CurrentVersion = ({ puzzles, latestVersion }) => {
  const [filters, setFilters] = useState({ difficulty: '', gridSize: '' });

  const filteredPuzzles = puzzles.filter(puzzle => 
    (filters.difficulty ? getDifficulty(puzzle.fice_score) === filters.difficulty : true) &&
    (filters.gridSize ? puzzle.pattern.length === parseInt(filters.gridSize) : true)
  );

  return (
    <div className="current-version">
      <h2>Current Version: {latestVersion?.version}</h2>
      <p>Puzzle count: {puzzles.length}</p>
      <div className="filters">
        <select 
          value={filters.difficulty} 
          onChange={(e) => setFilters({...filters, difficulty: e.target.value})}
        >
          <option value="">All Difficulties</option>
          <option value="Easy">Easy</option>
          <option value="Medium">Medium</option>
          <option value="Hard">Hard</option>
          <option value="Expert">Expert</option>
        </select>
        <select 
          value={filters.gridSize} 
          onChange={(e) => setFilters({...filters, gridSize: e.target.value})}
        >
          <option value="">All Sizes</option>
          <option value="4">4x4</option>
          <option value="8">8x8</option>
        </select>
      </div>
      <PuzzleGrid puzzles={filteredPuzzles} />
    </div>
  );
};

export default CurrentVersion;